import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {IErrorState, initialErrorState} from '@app/core/store/state/error.state';

export const errorReducers = (
	state = initialErrorState,
	action: ErrorActions,
): IErrorState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				loadError: action,
			};
		}
		default:
			return state;
	}
};
